import {FC} from 'react'

interface Props {
  name: string
}

const RoleNameCell: FC<Props> = ({name}) => (
  <div className='d-flex align-items-center'>
    <div className='d-flex flex-column'>
      <span className='text-gray-800 text-hover-primary mb-1'>{name}</span>
    </div>
  </div>
)

export {RoleNameCell} 